<template>
    <div :class="{'grow' : enabled}" class="th flex items-center pointer button" @click.stop="onClick" style="user-select:none">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        enabled: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        onClick() {
            if (this.enabled) {
                this.$emit('click');
            }
        }
    }
};
</script>
